/*!
 * RegexTest(pattern, text)
 *
 * Executes a search for a match between a regular expression and a specified string.
 *
 * SAMPLES
 * RegexTest(/^Hello/, "Hello world") -> True
 * RegexTest(/^\d{ 10}$/, "1234567890") -> True
 *
 * INPUT
 * pattern: The pattern to match.
 * text: The string against which to match the Regex.
 *
 * OUTPUT
 * Returns True if it finds a match with the regular expression, otherwise, it returns False.
 */
function RegexTest(pattern, text) {
  if (
    pattern === null ||
    pattern === undefined ||
    pattern.length === 0 ||
    text === null ||
    text === undefined ||
    text.length === 0
  ) {
    return false;
  }
  return new RegExp(pattern).test(text);
}

export default {
  RegexTest,
};
